import { Component, input, contentChild } from '@angular/core';
import { CardHeaderDirective } from './card-header.directive';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-aw-card',
    templateUrl: 'card.component.html',
    styles: [
        `
            :host {
                display: flex;
                flex-direction: column;
            }
        `,
    ],
    imports: [MatCardModule, NgClass, NgTemplateOutlet],
})
export class CardComponent {
    readonly title = input<string>(undefined);
    readonly contentClasses = input<string>(undefined);
    readonly cardClasses = input<string>(undefined);

    readonly cardHeader = contentChild(CardHeaderDirective);

    constructor() {}
}
